module.exports = __webpack_public_path__ + "img/images_homebanner_4-1.b9836ac9.png";